export const PermissionsList = {
  UserView: "user.view",
  UserCreate: "user.create",
  UserUpdate: "user.update",
  UserDelete: "user.delete",
  UserSkillUpadte: "user.skill.update",
  RoleView: "role.view",
  RoleCreate: "role.create",
  RoleUpdate: "role.update",
  RoleDelete: "role.delete",
  EventViewAll: "event.view.all",
  EventView: "event.view",
  EventCreate: "event.create",
  EventUpdate: "event.update",
  EventDelete: "event.delete",
  EventImport: "event.import",
  EventSkillViewAll: "event.skill.view.all",
  EventSkillView: "event.skill.view",
  EventReportCreate: "event.report.create",
  EventRoleCreate: "event.role.create",
  EventRoleUpdate: "event.role.update",
  EventRoleDelete: "event.role.delete",
  EventTypeView: "event.type.view",
  EventTypeCreate: "event.type.create",
  EventTypeUpdate: "event.type.update",
  EventTypeDelete: "event.type.delete",
  EventNotificationViewAll: "event.notification.view.all",
  EventNotificationView: "event.notification.view",
  EventNotificationCreate: "event.notification.create",
  EventNotificationDelete: "event.notification.delete",
  SkillView: "skill.view",
  SkillCreate: "skill.create",
  SkillUpdate: "skill.update",
  SkillDelete: "skill.delete",
  ParticipantViewAll: "participant.view.all",
  ParticipantWithLabelView: "participant.with_labels.view",
  ParticipantView: "participant.view",
  ParticipantCreate: "participant.create",
  ParticipantUpdate: "participant.update",
  ParticipantDelete: "participant.delete",
  SponsorView: "sponsor.view",
  SponsorCreate: "sponsor.create",
  SponsorUpdate: "sponsor.update",
  SponsorDelete: "sponsor.delete",
  PackageViewAll: "package.view.all",
  PackageView: "package.view",
  PackageCreate: "package.create",
  PackageUpdate: "package.update",
  PackageDelete: "package.delete",
  PackageParticipant: "package.participant",
  PackageQuotaViewAll: "package.quota.view.all",
  PackageQuotaView: "package.quota.view",
  PackageQuotaCreate: "package.quota.create",
  PackageQuotaUpdate: "package.quota.update",
  PackageQuotaDelete: "package.quota.delete",
  PackageQuotaBlock: "package.quota.block",
  ZoneView: "zone.view",
  ZoneCreate: "zone.create",
  ZoneUpdate: "zone.update",
  ZoneDelete: "zone.delete",
  ZoneStatus: "zone.status",
  ZoneSponsor: "zone.sponsor",
  ZoneBlock: "zone.block",
  ZonePublish: "zone.publish",
  TransferView: "transfer.view",
  TransferCreate: "transfer.create",
  TransferUpdate: "transfer.update",
  TransferDelete: "transfer.delete",
  FndView: "fnd.view",
  FndCreate: "fnd.create",
  FndUpdate: "fnd.update",
  FndDelete: "fnd.delete",
  FndOrganizationView: "fnd.organization.view",
  FndOrganizationCreate: "fnd.organization.create",
  FndOrganizationUpdate: "fnd.organization.update",
  FndOrganizationDelete: "fnd.organization.delete",
  ProjectViewAll: "project.view.all",
  ProjectView: "project.view",
  ProjectCreate: "project.create",
  ProjectUpdate: "project.update",
  ProjectDelete: "project.delete",
  ControlPointViewAll: "control-point.view.all",
  ControlPointView: "control-point.view",
  ControlPointCreate: "control-point.create",
  ControlPointUpdate: "control-point.update",
  ControlPointDelete: "control-point.delete",
  ControlPointStatus: "control-point.status",
  ControlPointAllStatus: "control-point.all-status",
  ControlPointDelegate: "control-point.delegate",
  ControlPointRequestViewAll: "control-point.request.view.all",
  ControlPointRequestView: "control-point.request.view",
  ControlPointRequestCreate: "control-point.request.create",
  ControlPointRequestDelete: "control-point.request.delete",
  ControlPointRequestModereate: "control-point.request.moderate"
};

export const RolesList = {
  Admin: "admin",
  EventAdmin: "event_admin",
  ChiefExpert: "chief_expert",
  SponsorManager: "sponsor_manager",
  SectorManager: "sector_manager",
  PackageManager: "package_manager",
  FndBlockLeader: "fnd_block_leader",
  FndEmployee: "fnd_employee",
  FndLeader: "fnd_leader",
  Moderator: "moderator",
  SubjectRegistar: "subject_registar"
};

export default {
  PermissionsList,
  RolesList,
};
